/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function LabelFromJSON(json) {
    return LabelFromJSONTyped(json, false);
}
export function LabelFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        id: !exists(json, 'id') ? undefined : json['id'],
        organizationId: !exists(json, 'organization_id') ? undefined : json['organization_id'],
        name: !exists(json, 'name') ? undefined : json['name'],
        color: !exists(json, 'color') ? undefined : json['color'],
        sort: !exists(json, 'sort') ? undefined : json['sort'],
        isSystem: !exists(json, 'is_system') ? undefined : json['is_system'],
        documentsCount: !exists(json, 'documents_count') ? undefined : json['documents_count'],
        createdAt: !exists(json, 'created_at') ? undefined : new Date(json['created_at']),
        updatedAt: !exists(json, 'updated_at') ? undefined : new Date(json['updated_at'])
    };
}
export function LabelToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        id: value.id,
        organization_id: value.organizationId,
        name: value.name,
        color: value.color,
        sort: value.sort,
        is_system: value.isSystem,
        documents_count: value.documentsCount,
        created_at: value.createdAt === undefined ? undefined : value.createdAt.toISOString(),
        updated_at: value.updatedAt === undefined ? undefined : value.updatedAt.toISOString()
    };
}
